import { KeyValue } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { GetKvs } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { StackContext } from "../context";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";

const syncKeyValues: GetKvs<ICustomVariables, SiteNativeTemplate> = (
  context: StackContext
): KeyValue[] => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const dl = context.services.dataLayerService!.dataLayer;

  const kvs = [
    {
      key: "primaryCategory",
      value: [dl.primaryCategory],
    },
    {
      key: "subCategory",
      value: [dl.subCategory1],
    },
    {
      key: "subCategory1",
      value: [dl.subCategory1],
    },
    {
      key: "talent_tags",
      value: dl.pageTags,
    },
    {
      key: "talent_themes",
      value: dl.pageThemes,
    },
    {
      key: "pageId",
      value: [dl.pageId ?? ""],
    },
    {
      key: "articleType",
      value: [dl.articleType],
    },
    {
      key: "locationPathName",
      value: [dl.locationPathName],
    },
    {
      key: "URL",
      value: [dl.locationHref],
    },
    {
      key: "pageTitle",
      value: [dl.pageTitle],
    },
  ];

  if (dl.primaryCategory === "frontpage") {
    kvs.push({
      key: "cat1",
      value: ["etusivu"],
    });
  }

  return kvs;
};

const adTargeting = {
  syncKvs: syncKeyValues,
};

export default adTargeting;
